import { render, staticRenderFns } from "./MixedTable.vue?vue&type=template&id=4f2a6496&scoped=true"
import script from "./MixedTable.vue?vue&type=script&lang=js"
export * from "./MixedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a6496",
  null
  
)

export default component.exports